import { defineComponent as _defineComponent } from 'vue'
import UserNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, onBeforeUnmount, reactive, onUpdated, watch } from "vue";
import UserListDataService from "@/services/UserListDataService";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref("User Maintenance");
const listtitle = ref("User Inquiry");
const userListInfo = reactive([]);
const selectedDestination = ref("");
const destinationList = reactive([]);
const isNoData = ref(false);

/** 初期表示設定 */
onMounted(function () {
  window.addEventListener('resize', handleResize);
  if(store.getters.stationListData != null){
    destinationList.splice(0);
    destinationList.push(store.getters.stationListData);
  }
  changeScreenFlg();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

function handleResize() {
  if (store.getters.isPageLoad == true) {
    changeScreenFlg();
  }
  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("tbltbody")?.clientHeight;
    if (dataHeight != 0) {
      var mydivh = document.getElementById("mydiv")?.clientHeight;
      tableHeight = (mydivh * 96) / 100 - 184;
      document.getElementById("tblbodydiv").style.height = tableHeight + "px";
      if (dataHeight > tableHeight) {
        document.getElementById("tblbodydiv").style.width = "100%";
      } else {
        document.getElementById("tblbodydiv").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
}

watch(
  () =>  [store.getters.stationCode, store.getters.stationListData],
  function () {
    if(store.getters.stationListData != null){
      destinationList.splice(0);
      destinationList.push(store.getters.stationListData);
    }
    changeScreenFlg();
  }
);

const changeScreenFlg = () => {
  userListInfo.splice(0);
  isNoData.value = false;
  selectedDestination.value = store.getters.stationListData != null? destinationList[0][0].stationCode : "";
  if (store.getters.stationCode != "1000") {
    selectedDestination.value = store.getters.stationCode;
    if(store.getters.isPageLoad == true){
      goSearch();
    }
  }
  if(store.getters.searchedUserList != null && store.getters.isPageLoad == false){
    selectedDestination.value = store.getters.selectedStation;
    for(let userObj of store.getters.searchedUserList){
      userListInfo.push(userObj);
    }
  }
  store.dispatch("setIsPageLoad",false);
};

/** 検索処理 */
const goSearch = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  isLoading.value = true;
  userListInfo.splice(0);
  isNoData.value = false;

  selectedDestination.value = store.getters.stationCode != '1000' ? store.getters.stationCode: selectedDestination.value;
  const param = {
    stationCode: selectedDestination.value
  };
  UserListDataService.getUserInquiry(param)
    .then((response: ResponseData) => {
    if (response.data.length > 0) {
      store.dispatch("setSearchedUserList", response.data);
      for(let userObj of response.data){
        userListInfo.push(userObj);
      }
    } else {
      isNoData.value = true;
    }
    isLoading.value = false;
  })
  .catch((e: Error) => {
    console.log(e);
    alertMessage.value = i18n.t("err012");
    alertState.value = "error";
    isLoading.value = false;
  });
};

/** ユーザー情報画面へ遷移 */
const userIDClick = (userInfo) => {
  if (store.getters.Flg != 'UserList') {
    store.dispatch("setFlg", "UserMaintenance");
  } else {
    store.dispatch("setFlg", "UserList");
  }
  store.dispatch("setuserId", userInfo.userId);
  store.dispatch("setSelectedStation", selectedDestination.value);
  store.dispatch("setShowPage", "UserInformation");
};

/** ユーザー権限編集画面へ遷移 */
const userPermissionClick = (info) => {
  if(store.getters.stationCode == 1000 && info.stationcode != selectedDestination.value)
  {
    alert(i18n.t("alt082"));
  }
  else{
    store.dispatch("setUserdata", info.userId);
    store.dispatch("setShowPage", "UserMaintenance");
    store.dispatch("setSelectedStation", selectedDestination.value)
  }
};

/** ユーザー情報のStatus更新 */
const updateUserStatus = (userId, status) => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  isLoading.value = true;
  const param = {
    userId: userId,
    status: status,
  };
  if (status == "deleted") {
    if (confirm(i18n.t("cnf008"))) {
      UserListDataService.updateUserStatus(param)
        .then((response: ResponseData) => {
          if (response.data == 201) {
            goSearch();
          }
          isLoading.value = false;
        })
        .catch((e: Error) => {
          console.log(e);
          alertMessage.value = i18n.t("err023");
          alertState.value = "error";
          isLoading.value = false;
        });
    } else {
      isLoading.value = false;
    }
  } else {
    UserListDataService.updateUserStatus(param)
      .then((response: ResponseData) => {
        if (response.data == 201) {
          goSearch();
        }
        isLoading.value = false;
      })
      .catch((e: Error) => {
        console.log(e);
        alertMessage.value = i18n.t("err023");
        alertState.value = "error";
        isLoading.value = false;
      });
  }
};

onUpdated(function () {
  handleResize();
});

const __returned__ = { isLoading, alertMessage, alertState, i18n, title, listtitle, userListInfo, selectedDestination, destinationList, isNoData, handleResize, changeScreenFlg, goSearch, userIDClick, userPermissionClick, updateUserStatus, UserNavigation, Loading, Alert, store }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})